import classNames from 'classnames/bind';
import React from 'react';
import { RiToolsLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import AD3000 from './adsystem/AD3000';
import FixedWing from './aeroinsight/FixedWing';
import JIHOV2 from './aeroinsight/JI-HO_V2';
import Copter from './common/Copter';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Panel = ({ data: [robot] }) => {
  switch (robot.metadata['INSPECTION_MODEL_KEY']) {
    case 'adsystem/AD3000':
      return <AD3000 data={[robot]} />;

    case 'aeroinsight/FixedWing':
      return <FixedWing data={[robot]} />;

    case 'aeroinsight/JI-HO_V2':
      return <JIHOV2 data={[robot]} />;

    case 'common/Copter':
      return <Copter data={[robot]} />;

    default:
      return (
        <div className={cx('container')}>
          <div className={cx('wrapper')}>
            Inspection is not available for this vehicle.
            <br />
            Please contact us for assistance.
          </div>
        </div>
      );
  }
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Inspection';
Command.displayMode = 'overlay';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiToolsLine;
Command.Panel = Panel;

export default Command;
